import { useEffect, useRef, useState } from "react";
import Fullpage from "../components/Layout/Fullpage";
import style from "./style.module.css";
import ReactSimpleSelect from "../components/ReactSimpleSelect";
import axios from "axios";
import {
  ASSESSMENT_YEAR,
  DOCS_DELETE_FILE,
  TAX_GET_DOCUMENTS_API_URL,
  TAX_GET_UPLOADED_DOCUMENTS_API_URL,
  TAX_GET_USER_PAYMENT_STATUS_API_URL,
  TAX_ITR_DELETE_DOCS_API_URL,
  TAX_ITR_UPLOAD_DOCS_API_URL,
  GET_USER_ITR_DETAILS_API_URL,
  BASE_API_URL,
  TAX_GET_TAX_PLANS_API_URL,
  Add_Own_Foreign_Assets,
} from "../constants";
import { fetchData, getItemLocal, getParentUserId, getUserId, loginRedirectGuest, apiCall, setItemLocal } from "../common_utilities";
import { getuid } from "process";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from 'js-cookie'
import { trackWebEngageEvent } from "../Utils/Webengageevent/webengageUtils";
import data from "../components/LandingPage/data";
import Modal from "react-responsive-modal";
const ItrUploadDocs = () => {

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB").replace(/\//g, "-");
  };

  const [Documents, setDocumentData] = useState([]);
  const [UploadedDocuments, setUploadedDocuments] = useState([]);
  const [documentsName, setDocumentName] = useState([]);
  const [doctype, setdoctype] = useState("");
  const [oldPhoto, setOldPhoto] = useState({});
  const [remark, setRemark] = useState("");
  const [fileObj, setFileObj] = useState([]);
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [preview, setPreview] = useState();
  const [userItrData, setUserItrData] = useState({});
  const [skipCal, setSkipCal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [itrcouponCode, setItrcouponcode] = useState('');
  const [itrcoupondiscount, setItrcoupondiscount] = useState(0)
  const [netPayable, setNetPayable] = useState(0)
  const [discAmt, setDiscAmt] = useState(0)
  const [rmid, setRMId] = useState(null);

  const cookieRMId = Cookies.get("rm_id") || null;
  const tagval = Cookies.get("tagval") || null;
  const RMID = rmid ? rmid : cookieRMId ? cookieRMId : 96;
  const [itrplanId, setItrplanId] = useState(0)
  const userDetails = getItemLocal("useritrdata")
  let urlParams = new URLSearchParams(window.location.search);
  const utmService = urlParams.get("utm_service");
  const plan = getItemLocal("pid");
  const utm_source = Cookies.get("utm_source") || null;
  const uploadRef = useRef();
  const navigate = useNavigate();
  const member = getItemLocal('pd') ? getItemLocal('pd') : "";
  const docUserId = member.user_id;
  const [rememberMe, setRememberMe] = useState("");
  const [openitrdocmodal, setItrdocmodal] = useState(false);
  const [leadid, setLeadId] = useState(null);
  const onCloseSearchModal = () => {
    setItrdocmodal(false);
  };
  const handleRememberMe = (checked) => {
    setRememberMe(checked ? "Yes" : "No");
  };


  const onFileChange = (e, j) => {
    // Update the state
    // console.log("rrr", e.target.files[0].name);
    const a = UploadedDocuments;
    const b = documentsName;
    a[j]["readyToUpload"] = e.target.files[0];
    var reader = new FileReader();

    reader.onloadend = function () {
      a[j]["thumbnail"] = reader.result;
      setUploadedDocuments([...a]);
    };

    if (e.target.files[0]) {
      // console.log("thmb", e.target.files[0].name);
      reader.readAsDataURL(e.target.files[0]);
    }
    // setDocumentName([...b])
  };
  const CheckLead = async () => {
    try {
      const url = `${BASE_API_URL}restapi/userflow/check_lead_api/?user_id=${getUserId()}&log_service_id=91&assesment_year=Y`;
      const response = await fetch(url);
      const result = await response.json();

      if (result?.status_code === "200" && result?.data?.log_tag) {
        // setCalTag(result.data.log_tag);
        setRMId(result.data.log_rm_id)
        setLeadId(result.data.log_id)
      }
    } catch (error) {
      console.error("CheckLead API error:", error);
    }
  };

  useEffect(() => {
    if (getUserId() == null) return;
    // paymentStatus();
    CheckLead();

    if (document.querySelector("header")) {
      document.querySelector("header").classList.add("d-none");
    }
    return () => {
      if (document.querySelector("header")) {
        document.querySelector("header").classList.remove("d-none");
      }
    };
  }, []);

  useEffect(() => {
    const init = async () => {
      if (getUserId() == null) {
        // loginRedirectGuest();
      } else {
        fetchDocuments();
        await getUserItrData();
      }
    };

    init();
  }, []);

  useEffect(() => {
    if (userItrData?.UserITRID) {
      fetchUploadedDocuments();
    }
  }, [userItrData]);


  const getUserItrData = async () => {
    setItemLocal("sc", 0);
    let data = await apiCall(GET_USER_ITR_DETAILS_API_URL, {
      user_id: docUserId ? docUserId : getUserId(),
    });

    if (data.error_code === "100") {
      const userData = data.data?.[0];
      setUserItrData(userData);
      setRememberMe(userData.own_foreign_assets);

      if (userData?.Current_Filing_Step === "4") {
        setSkipCal(true);
        setItemLocal("sc", 1);
      }
    }
  };



  const deleteOldPhoto = async (v, j) => {
    setUploadedDocuments((x) => x.filter((xx, ii) => ii != j));
    try {
      var payload = {
        url: TAX_ITR_DELETE_DOCS_API_URL,
        data: {
          document_id: v.toString(),
          user_id: docUserId ? docUserId : getUserId(),
        },
        method: "post",
      };
      var response = await fetchData(payload);

      setOldPhoto({});
      dispatch({
        type: "RENDER_TOAST",
        payload: { message: response.message, type: "success" },
      });
    } catch (e) { }
  };

  const fetchDocuments = async () => {
    var res = await axios.post(TAX_GET_DOCUMENTS_API_URL, {});
    const index_data = res.data.data;
    setDocumentData(index_data);
  };

  console.log("userItrData", rememberMe, userItrData.own_foreign_assets);

  const fetchUploadedDocuments = async () => {
    const user_id = docUserId ? docUserId : getUserId()
    const user_itr_id = userItrData?.UserITRID;
    var res = await axios.post(TAX_GET_UPLOADED_DOCUMENTS_API_URL, {
      user_id: user_id,
      user_itr_id: user_itr_id,
      assesment_year: ASSESSMENT_YEAR
    });
    const doc_data = res.data.data.filter((v) => v.is_active == 1 && v.s3_link != "NA");
    setRemark(res.data?.itr_comment)
    if (doc_data.length > 0) {
      setUploadedDocuments(doc_data);
    } else {
      setUploadedDocuments([{ doc_type: UploadedDocuments.length }]);
    }
  };

  const paymentStatus = async () => {
    try {
      const res = await axios.post(TAX_GET_USER_PAYMENT_STATUS_API_URL, {
        user_id: getUserId(),
        check_payment: "1",
        assessment_year: ASSESSMENT_YEAR,
      });
      const result = res.data;
      if (result["error_code"] === "100") {
        setNetPayable(result.data[0]?.payment_amount)
        setItrcouponcode(result.data[0]?.c_code);
        setItrcoupondiscount(result.data[0]?.c_discount);
        setItrplanId(result.data[0]?.payment_plan)
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error in paymentStatus:", error);
      setIsLoading(false);
    }
  };



  useEffect(() => {
    paymentStatus();
  }, [])

  const onFileUpload = async () => {
    setIsDisabled(true);
    var i = 0;
    uploadRef.current = UploadedDocuments;

    let planData = {};
    try {
      const taxPlansResponse = await apiCall(TAX_GET_TAX_PLANS_API_URL, {});
      const taxPlans = taxPlansResponse?.data || [];
      planData = taxPlans.find(p => Number(p.plan_id) === Number(itrplanId)) || {};
    } catch (error) {
      console.error("Error fetching tax plans:", error);
    }

    const planOriginalPrice = Number(planData.plan_original_price) || 0;
    const paymentAmount = Number(netPayable) || 0;
    const listDiscount = planOriginalPrice - paymentAmount;
    const couponDiscount = Number(itrcoupondiscount) || 0;


    for await (var obj of UploadedDocuments) {
      if (Boolean(obj["readyToUpload"]) == true) {
        var file = obj["readyToUpload"];
      }

      let formdata = new FormData();
      formdata.append("doc_file", file);
      formdata.append("user_id", docUserId ? docUserId : getUserId());
      formdata.append("doc_type", obj.doc_type ? obj.doc_type : 1);
      formdata.append("no_enc_key", "AAAA");
      formdata.append("doc_name", "itr_Filling");
      formdata.append("remark", remark ? remark : " ");
      
      // remark != "" && formdata.append("remark", remark);
      
      var res = await fetchData({
        url: TAX_ITR_UPLOAD_DOCS_API_URL,
        method: "POST",
        data: formdata,
      });



      const docIdNameMap = {};
      Documents.forEach(doc => {
        docIdNameMap[doc.dt_id] = doc.dt_name;
      });
      const uploadedDocNames = UploadedDocuments
        .filter(doc => doc.doc_type in docIdNameMap)
        .map(doc => docIdNameMap[doc.doc_type])
        .join(", ");

      ownforeignAssets();

      trackWebEngageEvent("documents uploaded", {
        url: window.location.href,
        "list price": planOriginalPrice,
        MRP: planOriginalPrice,
        "total payable": planOriginalPrice,
        "list discount": couponDiscount,
        "plan name": planData.plan_name || "",
        "plan id": itrplanId || 0,
        service: "ITR",
        // "lead id": RMID,
        "lead id": String(leadid),
        name: userDetails?.first_name + ' ' + userDetails?.last_name ?? '',
        email: userDetails?.email ?? '',
        utm_source: utm_source ?? '',
        phone: userDetails?.mobile ?? '',
        dob: new Date(userDetails?.dob),
        gender: userDetails?.gender ?? '',
        Service: "ITR",
        "pan card": userDetails?.pan ? true  : false,
        "coupon code": itrcouponCode ?? '',
        "coupon discount": couponDiscount,
        "total price": paymentAmount,
        "failure reason": res.error_code == "103" ? res?.message : "",
        "uploaded documents": uploadedDocNames,
        "payment mode": '',
        "net payable": paymentAmount
      });

      uploadRef.current[i]["finishedUpload"] = false;
      if (res.error_code == 100) {
        uploadRef.current[i]["finishedUpload"] = true;
      }

      setUploadedDocuments([...uploadRef.current]);
      i++;

      setTimeout(() => {
        if (skipCal) {
          navigate(`${process.env.PUBLIC_URL}/approve-computation`);
          return;
        }
        navigate(`${process.env.PUBLIC_URL}/itr-Appointment`);
      }, 3500);
    }
  };


  const handleError = () => {
    dispatch({
      type: "RENDER_TOAST",
      payload: { message: "Please Select Document Type First.", type: "error" },
    });
    setErrorMessage("Please Select Document Type First.");
  };

  const openThumbnail = (base64DataUrl) => {
    console.log("openThumbnail", base64DataUrl)
    const byteCharacters = atob(base64DataUrl.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length).fill().map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);
    window.open(blobUrl);
  };


  // add_own_foreign_assets api

  const ownforeignAssets = async () => {

    const payload = {
      user_id: getUserId(),
      user_itr_id: String(userItrData.UserITRID),
      own_foreign_assets: rememberMe
    }

    var res = await fetchData({
      url: Add_Own_Foreign_Assets,
      method: "POST",
      data: payload,
    });

  }

  return (
    <>
      <Fullpage>
        <div>
          <div className="container">
            <div className="row">
              <div className="col-12 col-md-6">
                <h3 className="text-center display-6">Upload Documents</h3>
                <div
                  style={{
                    color: "#888",
                    fontWeight: "600",
                    textAlign: "center",
                  }}>
                  <span>Don't have documents now?<a href={`${process.env.PUBLIC_URL}/itr-Appointment`}
                    style={{
                      color: "#042b62",
                      fontWeight: "600",
                      cursor: "pointer",
                    }}
                  //onClick={navigateToAppointment}
                  > Skip</a></span>
                </div>
                <p className={`text-center ${style.subtitle}`}>
                  Kindly upload images size between 200kb to 500kb{" "}
                  {/* <i>(images types can include PNG, JPG, JPEG and BMP)</i> */}
                </p>
                {/* <div 
                style={{
                  color: "#888",
                  fontWeight: "600",
                  textAlign: "center",
                }}>
                  
                <span>Don't have documents now?<a href={`${process.env.PUBLIC_URL}/itr-Appointment`}
                style={{
                  color: "#042b62",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
                //onClick={navigateToAppointment}
              > Skip</a></span>
              </div>   */}
                <table className="table">
                  <thead>
                    <tr>
                      <th>File Type</th>
                      <th>Status</th>
                      <th style={{ width: 40 }}>&nbsp;</th>
                    </tr>
                  </thead>
                  <tbody>
                    {UploadedDocuments.map((v, j) => (
                      <tr className={style.trField}>
                        <td>
                          <ReactSimpleSelect
                            options={Documents.map((w) => {
                              return { title: w.dt_name, value: w.dt_id };
                            })}
                            value={v.doc_type}
                            onChange={(x) => {
                              const a = UploadedDocuments;
                              const i = a.findIndex(
                                (vv) => vv.doc_type == v.doc_type
                              );
                              a[i]["doc_type"] = x;
                              setUploadedDocuments([...a]);
                              // console.log('uu889', x, a.findIndex((vv)=> vv.doc_type == v.doc_type), UploadedDocuments);
                            }}
                          />
                        </td>
                        <td>
                          <>
                            {(Boolean(v.s3_link) || Boolean(v.thumbnail)) && (
                              <div className="d-flex">
                                {Boolean(v.thumbnail) && (
                                  <>
                                    <div>
                                      <p className="mb-0">
                                        {"..." +
                                          v.readyToUpload.name.substring(
                                            v.readyToUpload.name.length - 20,
                                            v.readyToUpload.name.length
                                          )}
                                      </p>
                                      <p
                                        className={`mb-0 ${style["preview-link"]}`}
                                        onClick={() => {
                                          openThumbnail(v.thumbnail);
                                        }}
                                      >
                                        Preview
                                      </p>
                                    </div>
                                  </>
                                )}
                                {Boolean(v.s3_link) && (
                                  <>
                                    <div>
                                      <p className="mb-0">
                                        {"..." +
                                          v.s3_link.substring(
                                            v.s3_link.length - 20,
                                            v.s3_link.length
                                          )}
                                      </p>
                                      <a
                                        className={`mb-0 ${style["preview-link"]}`}
                                        href={v.s3_link}
                                        target="_blank"
                                      >
                                        Preview
                                      </a>
                                    </div>
                                  </>
                                )}

                                {Boolean(v.finishedUpload) && (
                                  <i
                                    style={{
                                      paddingLeft: "1rem",
                                      color: "green",
                                    }}
                                    class="fa-solid fa-check"
                                  ></i>
                                )}
                              </div>
                            )}
                          </>

                          {Boolean(v.thumbnail) == false &&
                            Boolean(v.s3_link) == false && (
                              <>
                                <div
                                  className={`${style.buttonChoose} d-inline-flex pointer`}
                                  onClick={() => {
                                    if (v.doc_type == "") {
                                      handleError();
                                    } else {
                                      document
                                        .querySelector("#file-" + j)
                                        .click();
                                    }
                                  }}
                                >
                                  <input
                                    type="file"
                                    id={"file-" + j}
                                    onChange={(e) => onFileChange(e, j)}
                                    style={{
                                      display: "none",
                                    }}
                                  />
                                  <div className={style.imagebox}>
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/static/media/ITR/up-loading_3.png"
                                      }
                                    />
                                  </div>
                                  <div className={style.chooseText}>
                                    Choose File
                                  </div>
                                </div>
                              </>
                            )}
                        </td>
                        <td>
                          <div
                            onClick={() => {
                              //if (v.doc_id != "" || v.doc_id != null)
                              deleteOldPhoto(v.doc_id, j);
                            }}
                          >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="py-3">
                  <p
                    className={style.addMoreBtn}
                    onClick={() => {
                      const a = UploadedDocuments;
                      a.push({ doc_type: "" });
                      setUploadedDocuments([...a]);
                    }}
                  >
                    + Add More
                  </p>
                </div>

                {/*  */}

                {console.log("rememberMe", rememberMe)}
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <input
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "20px"
                      }}
                      type="checkbox"
                      name="itrdoccheck"
                      value={rememberMe}
                      className="custom-checkbox"
                      id="itrdoccheck"
                      checked={rememberMe === "Yes"}
                      onChange={(e) => {
                        handleRememberMe(e.target.checked)
                      }}
                    />

                    <label for="itrdoccheck" style={{ color: "#042b62", fontWeight: "500", fontSize: "1rem" }} className={`pointer ${style.subtitle}`}>
                      Do you own any foreign assets?
                    </label>

                    <img
                      onClick={() => {
                        setItrdocmodal(true)
                      }}
                      alt="More information"
                      className="pointer"
                      src="https://images.minty.co.in/static/assets/img/more_information.svg"
                    />
                  </div>

                </div>



                <div className="py-3">
                  <textarea
                    rows="3"
                    className={style.textarea}
                    value={remark ? remark : ''}
                    placeholder="If you have any comments or queries related to ITR, Please mention here!"
                    onChange={(e) => {
                      setRemark(e.target.value);
                    }}
                  ></textarea>
                </div>
                <div className="pt-3 mb-4">
                  <button
                    disabled={isDisabled}
                    type="button"
                    className={style.btn}
                    onClick={() => onFileUpload()}
                  >
                    {"Save & Continue"}
                  </button>
                </div>
                {/* <center>
                  <div
                    style={{
                      color: "#042b62",
                      fontWeight: "600",
                      cursor: "pointer",
                      padding: " 05px 15px",
                    }}
                    onClick={navigateToAppointment}
                  >
                    Skip
                  </div>
                </center> */}
              </div>
              <div className="d-none d-md-block col-6">
                <img
                  className="img-fluid"
                  src={
                    process.env.PUBLIC_URL +
                    "/static/media/ITR/01_personal_data.21c9b7453073cdd0b44e.png"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </Fullpage>


      {/* foreign assets modal */}

      <Modal
        open={openitrdocmodal}
        onClose={onCloseSearchModal}
        center
        animationDuration={300}
        closeOnOverlayClick={false}
        classNames={{
          overlay: style.customOverlay,
          modal: style.customModal,
        }}
      >
        <div className={`${style['modal-content-wrapper']}`}>
          <h2 className={`${style['modal-heading']}`}>Who Needs to Report Foreign Assets?</h2>
          <p className={`${style["modal-text"]}`}>
            NRIs and R/NORs (Resident but Not Ordinarily Resident) are exempt.
            <br />
            But if you are a Resident and Ordinarily Resident (ROR) – <strong style={{fontWeight : "600"}}>Reporting is Mandatory.</strong>
          </p>

          <h2 className={`${style['modal-heading']}`}>Consequences of Non-Compliance?</h2>
          <p className={`${style["modal-text"]}`}>
            If foreign income or assets are not disclosed:
            <br />
            <strong style={{fontWeight : "600"}}>  Penalty of ₹10 lakh per default under Black Money (Undisclosed Foreign Income and Assets) Act
              and              Imprisonment up to 7 Years</strong>
          </p>


          <p className={`1${style["modal-note"]}`}>
            <strong>Note:</strong> Even inadvertent omission can cause scrutiny and delay in processing.
          </p>

          <div className="modal-actions">
            <button
              type="button"
              className={style.btn}
              onClick={() => {
                setItrdocmodal(false)
              }}
            >
              I understand
            </button>
          </div>
        </div>
      </Modal>


    </>
  );
};
export default ItrUploadDocs;
